// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Af84","fullView":"styles_fullView__1T3X0"};